import { Component, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ResponsiveService } from '../../service/responsive.service';
import { GenerateRouteService } from '../../service/generate-route.service';
import { TranslationModeEnum } from '../../enum/translation-mode-enum';
import { I18nService } from '../../service/i18n.service';
import { Language } from '../../model/language';
import { Subscription, filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { WindowService } from '../../service/window.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('languageSelector') languageSelector!: MatSelect;
  isLandscape: boolean = this.responsiveService.isLandscape();
  translationModes: typeof TranslationModeEnum = TranslationModeEnum;
  selectedLanguage: string = this.i18nService.getCurrentLanguage().code;
  currentLanguage: Language = this.i18nService.getCurrentLanguage();
  routeSubscription!: Subscription;
  panelIsOpen: boolean = false;
  languageIsOpen: boolean = false;
  scrolled: boolean = false;
  languageLabels = {
    es: 'header_Data5',
    en: 'header_Data6',
    pt: 'header_Data7',
    fr: 'header_Data8',
    eus: 'header_Data9',
    cat: 'header_Data10'
  };

  constructor(
    private responsiveService: ResponsiveService,
    private generateRouteService: GenerateRouteService,
    private i18nService: I18nService,
    private router: Router,
    private renderer: Renderer2,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.selectedLanguage = this.i18nService.getCurrentLanguage().code;
      this.panelIsOpen = false;
      this.languageIsOpen = false;
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  /**
  * Obtiene la ruta en función del idioma actual
  * @param routeKey
  * @returns
  */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }

  /**
   * Actualiza el zoom al redimensionar la ventana
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isLandscape = this.responsiveService.isLandscape();
  }

  /**
   * Si se hace scroll cambia el navbar
   * @param event
   */
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    this.checkScroll();
    if (this.languageIsOpen) {
      this.languageSelector.close();
    }
  }

  /**
   * Gestiona si el usuario abre el menú en versión móvil
   */
  handleOpenChange() {
    this.panelIsOpen = !this.panelIsOpen;
  }

  /**
  * Gestiona si el usuario abre el selector de idioma
  */
  handleLanguageSelector() {
    this.languageIsOpen = !this.languageIsOpen;
  }

  /**
   * Obtiene la entrada i18n en función del idioma seleccionado
   * @returns
   */
  getSelectedLanguageLabel(): string {
    return this.languageLabels[this.selectedLanguage] || '';
  }

  /**
   * Establece el idioma
   * @param code
   */
  setCurrentLanguage(code: string) {
    this.i18nService.setCurrentLanguage(code);
    document.querySelector('html')?.setAttribute('lang', code);
    this.currentLanguage = this.i18nService.getCurrentLanguage();
    this.generateRouteService.updateRoute(this.currentLanguage.code);
  }

  /**
   * Revisa si el usuario ha hecho scroll en la página
   */
  private checkScroll(): void {
    if (this.windowService.isBrowser) {
      this.scrolled = window.scrollY > 0;
    }
  }
}
